<template>
  <div class="base-info">
    <div class="user-info" v-if="!hasPermissionNot(this.userInfo.roleActionList, 'no_show_base')">
      <div class="user-avatar">
        <CustImg class="user-avatar" :src="avatar" :defaultSrc="DEFAULT_AVATAR" />
      </div>
      <div class="user-name">
        <div class="name ellipsis-inline">{{ $t('home.hello') }}{{ agentName }}</div>
        <div class="date">{{ dateStr }}</div>
      </div>
    </div>
    <div class="enterprise-info" v-if="!hasPermissionNot(this.userInfo.roleActionList, 'no_show_base')">
      <div style="display: flex">
        <div style="width: 50%;">
          {{ $t('home.enterpriseId') }}{{ vccInfo.vccId
          }}<i class="iconfont icon-copy2" @click="copy(vccInfo.vccId)" :title="$t('home.clickCopyEnterpriseId')"></i>
        </div>
        <div style="width: 50%;">
          {{ $t('home.enterpriseCode') }}{{ vccInfo.vccCode
          }}<i class="iconfont icon-copy2" @click="copy(vccInfo.vccCode)" :title="$t('home.clickCopyEnterpriseCode')"></i>
        </div>
      </div>
      <div>
        <span>{{ $t('home.validPeriod') }}{{ vccInfo.openDate }}{{ $t('home.to') }}</span>
        <span :style="{ color: remainingDays < 30 ? 'red' : '' }">{{ vccInfo.dueDate }}</span>
        <span v-if="remainingDays < 1" style="color:red">({{ $t('home.expired') }})</span>
        <span v-else-if="remainingDays < 30" style="color:red">({{ $t('home.expiringSoon', { days: remainingDays }) }})</span>
      </div>
      <!-- <div>账号数：{{ vccInfo.agentLogins }}</div> -->
    </div>
    <div class="realData" v-if="!hasPermissionNot(this.userInfo.roleActionList, 'no_show_license')">
      <div class="realData-item">
        <div class="title">
          <span>{{ $t('home.skillGroupCount') }}</span>
          <el-tooltip class="item" effect="dark" :content="$t('home.skillGroupTip')" placement="top">
            <i class="iconfont icon-xinxiquan-line"></i>
          </el-tooltip>
        </div>
        <div class="data">
          <span class="color">{{ vccInfo.licenseInfo.queue.alreadyTotalQueue
            }}</span>/<span>{{ vccInfo.licenseInfo.queue.maxCreateQueue || $t('home.noLimit') }}</span>
        </div>
      </div>
      <div class="realData-item">
        <div class="title">{{ $t('home.ivrLineCount') }}</div>
        <div class="data">
          <span class="color">{{ vccInfo.licenseInfo.ivr.ivrLines }}</span>
        </div>
      </div>
      <div class="realData-item">
        <div class="title">
          <span>{{ $t('home.agentCount') }}</span>
          <el-tooltip class="item" effect="dark" :content="$t('home.agentCountTip')" placement="top">
            <i class="iconfont icon-xinxiquan-line"></i>
          </el-tooltip>
        </div>
        <div class="data">
          <span class="color">{{ vccInfo.licenseInfo.existsAgents.alreadyTotalAgents
            }}</span>/<span>{{ vccInfo.licenseInfo.agents.ccAgents }}</span>/<span>{{
          vccInfo.licenseInfo.agents.maxCreateAgents }}</span>
        </div>
      </div>
      <div class="realData-item">
        <div class="title">
          <span>{{ $t('home.adminAccount') }}</span>
          <!-- <el-tooltip class="item" effect="dark" content="已创建管理坐席数/管理坐席数" placement="top">
            <i class="iconfont icon-xinxiquan-line"></i>
          </el-tooltip> -->
        </div>
        <div class="data">
          <span class="color">{{ vccInfo.licenseInfo.existsAgents.adminAgents }}</span>/<span>{{
          vccInfo.licenseInfo.agents.adminAgents }}</span>
        </div>
      </div>
      <div class="realData-item">
        <div class="title">
          <span>{{ $t('home.callCenter') }}</span>
          <!-- <el-tooltip class="item" effect="dark" content="已有呼叫中心坐席数/最多登录呼叫中心坐席数" placement="top">
            <i class="iconfont icon-xinxiquan-line"></i>
          </el-tooltip> -->
        </div>
        <div class="data">
          <span class="color">{{ vccInfo.licenseInfo.existsAgents.ccAgents }}</span>/<span>{{
          vccInfo.licenseInfo.agents.ccAgents }}</span>
        </div>
      </div>
      <div class="realData-item">
        <div class="title">{{ $t('home.onlineService') }}</div>
        <div class="data">
          <span class="color">{{ vccInfo.licenseInfo.existsAgents.chatAgents }}</span>/<span>{{
          vccInfo.licenseInfo.agents.chatAgents }}</span>
        </div>
      </div>
      <div class="realData-item">
        <div class="title">{{ $t('home.ticket') }}</div>
        <div class="data">
          <span class="color">{{ vccInfo.licenseInfo.existsAgents.ticketAgents }}</span>/<span>{{
          vccInfo.licenseInfo.agents.ticketAgents }}</span>
        </div>
      </div>
      <div class="realData-item">
        <div class="title">{{ $t('home.voiceAssist') }}</div>
        <div class="data">
          <span class="color">{{ vccInfo.licenseInfo.existsAgents.realtimeAssistAgents }}</span>/<span>{{
          vccInfo.licenseInfo.iaa.realtimeAssistAgents }}</span>
        </div>
      </div>
      <div class="realData-item">
        <div class="title">{{ $t('home.videoService') }}</div>
        <div class="data">
          <span class="color">{{ vccInfo.licenseInfo.existsAgents.videoAgents }}</span>/<span>{{
          vccInfo.licenseInfo.agents.videoAgents }}</span>
        </div>
      </div>
      <div class="realData-item">
        <div class="title">{{ $t('home.textAssist') }}</div>
        <div class="data">
          <span class="color">{{ vccInfo.licenseInfo.existsAgents.textAssistAgents }}</span>/<span>{{
          vccInfo.licenseInfo.iaa.textAssistAgents }}</span>
        </div>
      </div>
      <div class="realData-item">
        <div class="title">{{ $t('home.callQuality') }}</div>
        <div class="data">
          <span class="color">{{ vccInfo.licenseInfo.existsAgents.sqcCc }}</span>/<span>{{
          vccInfo.licenseInfo.qc.sqcCc }}</span>
        </div>
      </div>
      <div class="realData-item">
        <div class="title">{{ $t('home.textQuality') }}</div>
        <div class="data">
          <span class="color">{{ vccInfo.licenseInfo.existsAgents.sqcChat }}</span>/<span>{{
          vccInfo.licenseInfo.qc.sqcChat }}</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import mixins from "@/mixins";

export default {
  name: "base-info",
  mixins: [mixins],
  mounted() {
    this.updateDate();
    this.timer = setInterval(() => {
      this.updateDate();
    }, 10000);
  },
  data() {
    return {
      DEFAULT_AVATAR: this._config.DEFAULT_AVATAR,
      timer: null,
      dateStr: "",
    };
  },
  computed: {
    ...mapGetters(["userInfo"]),
    avatar() {
      return this.userInfo.avatar || this.DEFAULT_AVATAR;
    },
    agentName() {
      const { userName = "", userNum = "" } = this.userInfo;
      return `${userName} ${userNum}`;
    },
    vccInfo() {
      const {
        vccCode = "",
        vccId = "",
        vcc: { agentLogins = 0, openDate = "", dueDate = "", licenseInfo = {} } = {},
      } = this.userInfo || {};
      return { vccId, vccCode, agentLogins, openDate, dueDate, licenseInfo };
    },
    // 剩余天数
    remainingDays() {
      // 获取当天日期
      let year = new Date().getFullYear()
      let month = new Date().getMonth() + 1
      let date = new Date().getDate()
      //截止日期的时间戳（+86400000是因为如果截止日期是当天的话，其实是剩一天到期）
      let Deadline = new Date(this.vccInfo.dueDate).getTime() + 86400000
      //当前日期（0时0分0秒）的时间戳
      let currentDate = new Date(`${year}-${month}-${date}`).getTime()
      let remainingDays = (Deadline - currentDate) / 1000 / 60 / 60 / 24
      return Math.floor(remainingDays)
    }
  },
  methods: {
    updateDate() {
      const week = [
        this.$t('common.sunday'),
        this.$t('common.monday'),
        this.$t('common.tuesday'),
        this.$t('common.wednesday'),
        this.$t('common.thursday'),
        this.$t('common.friday'),
        this.$t('common.saturday'),
      ];
      let now = new Date();
      let year = now.getFullYear();

      let month = now.getMonth() + 1 + "";
      month = month.padStart(2, "0");

      let date = now.getDate() + "";
      date = date.padStart(2, "0");

      let hour = now.getHours() + "";
      hour = hour.padStart(2, "0");

      let minutes = now.getMinutes() + "";
      minutes = minutes.padStart(2, "0");

      let day = now.getDay();

      this.dateStr = `${year}-${month}-${date} ${hour}:${minutes} ${week[day]}`;
    },
    copy(vccCode) {
      try {
        let input = document.createElement("input"); // 创建input对象
        input.value = vccCode; // 设置复制内容
        document.body.appendChild(input); // 添加临时实例
        input.select(); // 选择实例内容
        document.execCommand("Copy"); // 执行复制
        document.body.removeChild(input); // 删除临时实例
        this.$message({ message: this.$t('home.copySuccess'), type: "success" });
      } catch (error) {
        this.$message({ message: this.$t('home.copyFailed'), type: "error" });
      }
    },
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer);
    }
  },
};
</script>
<style lang="less" scoped>
.base-info {
  box-sizing: border-box;
  // height: 205px;
  padding: 16px;

  .user-info {
    display: flex;
    font-family: PingFangSC-Regular;

    .user-avatar {
      width: 40px;
      margin-right: 12px;
    }

    .user-name {
      flex: 1;
      overflow: hidden;

      .name {
        font-weight: 500;
        font-size: 14px;
        color: #323233;
        line-height: 22px;
      }

      .date {
        font-weight: 400;
        font-size: 12px;
        color: #969799;
        line-height: 20px;
      }
    }
  }

  .enterprise-info {
    font-family: PingFangSC-Regular;
    font-weight: 400;
    font-size: 12px;
    color: #646566;
    line-height: 24px;
    padding: 10px 0;
    border-bottom: 1px dashed #EBEDF0;

    .iconfont {
      font-size: 12px;
      margin-left: 6px;

      &.icon-copy2 {
        cursor: pointer;
      }
    }
  }

  .realData {
    display: flex;
    flex-wrap: wrap;
    font-size: 12px;
    line-height: 20px;
    margin-top: 8px;

    &>.realData-item {
      width: 33%;
      padding: 4px;
      box-sizing: border-box;

      &>.title {
        color: #646566;
        display: flex;
        align-items: center;
        height: 20px;
        line-height: 20px;

        &>span {
          line-height: 1;
        }

        &>.iconfont {
          font-size: 12px;
          margin-left: 4px;
          line-height: 1;
        }
      }

      &>.data {
        color: #323233;
        font-weight: 600;

        &>.color {
          color: #0090FF;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/Home/homeTab/baseInfo/index.vue